module.exports = __webpack_public_path__ + "img/ac8cfc8.jpg";